import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';

import LloydLogoChooser from "./LloydLogoChooser";

/**
 * If you'd like to customise your mats with a logo,
 * select the checkboxes above to reveal options.
 */
export default function CustomiserTabs({...props}) {
  const {lloyd, callbacks} = props;

  function selectTab(index, lastIndex, evt) {
    let tabs = getTabConfig(lloyd);
    let isPlain = ((+index + 1) == _.size(tabs));  // last tab click'd?

    if (isPlain) {
      callbacks.updateCart((cart) => cart.clearCustomisations());
    }

  }

  // sanity check on weird import
  if (!Tab) {
    console.error("CustomiserTabs: Tab library not loaded")
    return null;
  }

  let tabs = getTabConfig(lloyd);

  // <em className="tabs-or">or</em>
  return <Tabs onSelect={selectTab}>
    <TabList>
      {tabs.logo ? <Tab key="logo">Logo </Tab> : null}
      {tabs.lettering ? <Tab key="message">Custom Message <em className="tabs-or">or</em></Tab> : null}
      <Tab key="plain">Plain Mats</Tab>
    </TabList>

    {tabs.logo && <TabPanel key="logo">
      <div id="lloyd-tab-logo-inner">
        <LloydLogoChooser
          option={lloyd.getOption('logo')}
          {...props} />
      </div>
    </TabPanel>
    }

    <TabPanel key="plain" id="plain-mats-tab">
      <div id="lloyd-tab-plain-inner">
        <p>Plain mats selected with no customizations.</p>
      </div>
    </TabPanel>

  </Tabs>

}

function getTabConfig(lloyd) {
  let {options} = lloyd;

  // ["border","color","logo","logoThread","letteringThread","typestyle"]

  let tabs = {plain: true}
  if (options.logo)
    tabs.logo = true;

  // if (options.letteringThread) tabs.lettering=true;

  return tabs;
}

CustomiserTabs.propTypes = {
  cart: PropTypes.object,
  lloyd: PropTypes.object,
  callbacks: PropTypes.object
}
